import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    error: null,
    loading: false,
    data:''
} 

export const GetLumpingFaciltyReducer = createSlice({
    name: 'GetLumpingFaciltyReducer',
    initialState,
    reducers: {
        initiateLoading: (state) => {
          state.loading = true
         },
        addSuccess: (state, action) => {
           state.loading = false;
         state.data = action.payload;
        },
        addFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload
        },
        resetData:(state,action)=>{
            state.loading = false;
            state.data = ''; 
        }
    }
});

export const { addSuccess, addFailure,initiateLoading,resetData} = GetLumpingFaciltyReducer.actions;

// Selectors
export const getLumpingFaciltyReducer = (state) => {
    return state.GetLumpingFaciltyReducer;
};

export default GetLumpingFaciltyReducer.reducer;
